<template>
  <div class="page">
    <!-- 拿不到签到信息的时候展示原因 -->
    <div v-if="checkin == null && errcode > 0">
      <div class="error-box" v-if="errcode == 805">
        <img class="error-icon" src="https://cdn-xcxcustom.weiyoubot.cn/20210615/67599ce2a04eb8d67679b8376806f3dc.png" />
        <p class="error-title">该活动存在争议内容</p>
        <span class="error-text">请耐心等待有争议内容协商解决，有问题，请联系活动发起人</span>
      </div>
      <div class="error-box" v-if="errcode == 806">
        <img class="error-icon" src="https://cdn-xcxcustom.weiyoubot.cn/20210615/8ff8b64c0ef1065f300e980e8aae9bd5.png" />
        <p class="error-title">内容违规已被暂停</p>
        <span class="error-text">该内容被多人投诉，为维护绿色上网环境，已停止访问。</span>
      </div>
      <div class="error-box" v-if="errcode == 807">
        <img class="error-icon" src="https://cdn-xcxcustom.weiyoubot.cn/20210615/8ff8b64c0ef1065f300e980e8aae9bd5.png" />
        <p class="error-title">该活动已被删除</p>
        <span class="error-text">该活动已被发起人删除，如有疑问，请联系活动发起人</span>
      </div>
    </div>
    <!-- 可以拿到签到的信息，但是设置了加入审核导致不可展示 -->
    <div v-if="audit_status == 'ready'" class="audit-box padding-20-30">
      <van-image class="audit-img" src="http://image-custom.xiaoqiandao.com/20191218/c90a00864ce1b1e19c5740791a556d37.png" />
      <span class="text-28-99">发起人正在审核中，如果等待时间过长，可以自行联系发起人【<span style="color:#12b7f5">{{audit_name}}</span>】确认原因</span>
    </div>
    <div v-if="audit_status == 'reject'" class="audit-box padding-20-30">
      <van-image class="audit-img" src="https://cdn-xcxcustom.weiyoubot.cn/20200518/8bbaa03c8c9226f142af2b27e9b40f45.png" />
      <span class="text-28-99">您参与签到的申请已被拒绝，如有疑问请联系发起人【<span style="color:#12b7f5">{{audit_name}}</span>】确认原因</span>
    </div>
    <!-- 可以拿到签到信息展示签到信息 -->
    <div class="content" v-if="checkin != null">
      <div class="flex-column" style="background-color: #fff">
        <!-- 签到头部 -->
        <checkin-top :checkin="checkin"></checkin-top>       
        <!-- 活动说明 -->
        <activity-box :checkin="checkin" :hideInfo="!is_can_sign"></activity-box>
        <div class="divider"></div>
      </div>
      <div class="sign-code" v-if="!is_can_sign">     
        <img class="sign-img" :src="minQrcode">        
      </div>
      <!-- 普通签到 -->
      <div :class="!is_can_sign ? 'sign-panel' : ''">
        <div class="wx-panel" v-if="!is_can_sign">
          <wx-open-launch-weapp id="launch-btn" class="wx-btn" username="gh_eedd8c096654" appid="wxee55405953922c86" :path="'/pages/detail/detail.html?cid='+checkin.cid">
            <script type="text/wxtag-template">
              <div class="wx-btn" style="display:block;width:100%;height:40px;"></div>
            </script>
          </wx-open-launch-weapp>
        </div>      
        <div v-if="checkin.template == 0">
          <div @click="showDialog(2)" v-if="checkin.status==2" class="button gray">签到已结束</div>
          <div @click="joinCheckin" v-else-if="checkin.has_joined == 0" class="button yellow">参与签到</div>
          <div @click="showDialog(1)" v-else-if="checkin.status==0" class="button gray">签到未开始</div>
          <div @click="showDialog(4)" v-else-if="checkin.status == 3" class="button gray">{{checkin.checkinday[0]==8?'本周':(checkin.checkinday[0]==9?'本月':'今日')}}不用签到</div>
          <div v-else-if="checkin.status == 1">
            <div @click="checkinAction" v-if="checkin.has_checked<checkin.limit&&checkin.time_status==1" class="button">
              点击签到<span v-if="checkin.limit>1&&checkin.has_checked<checkin.limit">（已签{{checkin.has_checked}}次/共{{checkin.limit}}次）</span>
            </div>
            <div v-if="checkin.has_checked>=checkin.limit" class="button light">{{checkin.checkinday[0]==8?'本周':(checkin.checkinday[0]==9?'本月':'今日')}}签到已完成</div>
            <div @click="showDialog(3)" v-if="checkin.has_checked<checkin.limit&&checkin.time_status!=1&&checkin.time_status!=0" class="button light">不在签到时间内</div>
            <div v-if="checkin.has_checked<checkin.limit&&checkin.time_status==0" class="button light">当前时段已签到</div>
          </div>
        </div>
         <!-- 会议签到 -->
        <div v-if="checkin.template == 1">
          <div @click="joinCheckin" v-if="checkin.status != 2 &&checkin.has_joined == 0" class="button yellow">参与签到</div>
          <div v-else>
            <div @click="checkinAction" v-if="checkin.status == 1&&checkin.time_status==1" class="button">点击签到</div>
            <div @click="showDialog(4)" v-else-if="checkin.status==1&&checkin.time_status==0&&checkin.time_list.length==1" class="button light">
              {{checkin.checkinday[0]==8?'本周':(checkin.checkinday[0]==9?'本月':'今日')}}签到已完成
            </div>
            <div @click="showDialog(3)" v-if="checkin.status==1&&checkin.time_status!=1&&checkin.time_status!=0" class="button light">不在签到时间内</div>
            <div v-if="checkin.status==1&&checkin.time_status==0&&checkin.time_list.length>1" class="button light">当前时段已签到</div>
            <div @click="showDialog(1)" v-else-if="checkin.status==0" class="button gray">签到未开始</div>
            <div @click="showDialog(2)" v-if="checkin.status==2" class="button gray">签到已结束</div>
          </div>
        </div>
        <!-- 班级签到 -->
        <div v-if="checkin.template == 2">
          <div @click="joinCheckin" v-if="checkin.status != 2 &&checkin.has_joined == 0" class="button yellow">参与签到</div>
          <div v-else class="button" @click="joinCheckin">点击签到</div>
        </div>
        <!-- 签到动态 -->
        <record-list v-if="checkin.is_owner_cerficated == 1 && is_can_sign" class="top-20" :checkin="checkin" :hasUserInfo="hasUserInfo"></record-list>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString, getPc, getToken, wxLogin,isIos } from '@/utils/common.js'
import { Dialog, Toast } from 'vant'
import http from '@/utils/http'
import api from '@/utils/api'
import ActivityContent from '@/components/ActivityContent.vue'
import Avatar from '@/components/Avatar.vue'
import CheckinTop from '@/components/CheckinTop.vue'
import ActivityBox from '@/components/ActivityBox.vue'
import RecordList from '@/components/RecordList.vue'
export default {
  name: 'checkin',
  data: () => {
    return {
      showLoadErr: 0, //是否显示加载失败
      errcode: 0, //出现错误的错误码
      checkin: null, //获取到的签到信息
      hasUserInfo: getToken() ? true : false,
      expanded: false, //规则默认是否展开

      audit_status: '', // 加入需要审核的签到的审核状态 审核中=ready 被拒绝 reject
      audit_tip: '',
      audit_name: '',
      miniMessage: '',
      minQrcode: '',
      refer_uid:'',
      is_can_sign: false
    }
  },
  components: {
    ActivityContent,
    Avatar,
    CheckinTop,
    ActivityBox,
    RecordList,
  },
  created() {
    //   判断是否是微信web
    if (getPc() != 2 && getPc() != 3) {
      location.replace('http://www.xiaoqiandao.com')
      return
    }
    // 判断是否可以获得token
    if (!getToken()) {
      wxLogin().then((res) => {
        this.getCheckin()
      })
    } else {
      this.getCheckin()
    }
  },
  methods: {
    showDialog(flag) {
      let message = ''
      if (flag == 1) {
        message =
          '签到还未开始，暂时无法签到，可以先去设置里设置提醒时间，及时收到签到提醒。'
      } else if (flag == 2) {
        message = '签到活动已结束，无法签到'
      } else if (flag == 3) {
        message =
          '现在时间不在发起者设置的签到时间范围内，具体请看签到规则里的每日可签到时间。'
      } else if (flag == 4) {
        message =
          '现在时间不在发起者设置的签到周期范围内，具体请看签到规则里的签到周期。'
      }
      Dialog({
        title: '温馨提示',
        message: message,
        confirmButtonText: '我知道啦',
        confirmButtonColor: '#12b7f5',
      })
    },
    isNeedSign(){
      if(this.checkin.is_owner_cerficated != 1) {  
        this.miniMessage = '该签到尚未认证，请在小程序中使用'    
        return
      }
      if(this.checkin.wifis.length > 0){
        this.miniMessage = '该签到需要检查手机是否连接指定WiFi，请使用小程序签到'
        return
      }
      if(this.checkin.scan_required==1){
        this.miniMessage = '该签到需要通过扫码参与，请使用小程序加入'
        return
      }
      if(this.checkin.locations.length > 0){
        this.miniMessage = '该签到需要获取手机定位，请使用小程序签到'
        return
      }
      if(this.checkin.template == 2) {      
        this.miniMessage = '班级签到需要填写相关信息，请使用小程序加入'
        return
      }
      if(this.checkin.enable_audit == 1) {     
        this.miniMessage = '该签到需要发起签到审核申请才能参与，请使用小程序加入'
        return
      }
      // 参与签到需要名称与名单一致
      if (this.checkin.disable_free_join == 1) { 
        this.miniMessage = '该签到需要填写个人信息后才能加入，请使用小程序加入'  
        return
      }
      // 参与签到需要填写口令
      if (!this.checkin.has_joined && this.checkin.req_token) { 
        this.miniMessage = '该签到需要填写口令后才能加入，请使用小程序加入'        
        return
      }
      // 判断签到是否需要填写除文字外的信息
      let flag = 0
      for (let i = 0; i < this.checkin.fill_options.length; i++) {
        let item = this.checkin.fill_options[i]
        // 录音不可以
        if(item.field_key == 4 && item.status == 1 && item.require == 1) {
          flag = 1
          break
        }
        // 上传文件不可以
        if(item.field_key == 5 && item.status == 1 && item.require == 1) {
          flag = 1
          break
        }
        // 位置信息不可以
        if(item.field_key == 6 && item.status == 1 && item.require == 1) {
          flag = 1
          break
        }
        // 上传签名
        if(item.field_type == 10 && item.status == 1 && item.require == 1) {
          flag = 1
          break
        }
        // iOS上传视频不可以
        if(item.field_key == 3 && item.status == 1 && item.require == 1 && isIos()) {
          flag = 1
          break
        }
      }

      if (flag) {
        this.miniMessage = '该签到需要提交指定内容，请使用小程序签到'
      }else{
        this.is_can_sign = true;
      }
    },
    // 可以签到
    checkinAction() {
      // 前往签到页面
      if (this.checkin.template == 0) {
        // 普通签到
        if (this.checkin.pic_text) {
          localStorage.setItem('checkin', JSON.stringify(this.checkin))
          this.$router.push({
            name: 'checkin',
          })
        } else {
          this.doCheckin()
        }
      }
      if (this.checkin.template == 1) {
        // 会议签到
        this.doCheckin()
      }
    },
    doCheckin() {
      let data = {
        cid: this.checkin.cid,
        access_token: getToken(),
      }
      http.post(api.checkin.submit, data).then((res) => {
        let { count, rank } = res.data
        Toast.success('签到成功')
        this.$router.push({
          path: '/success',
          query: { count, rank },
        })
      })
    },
    getCheckin() {
      // 获取当前的cid
      let cid = getQueryString('cid')
      this.refer_uid = getQueryString('r') || ''
      if (cid) {
        // 获取考勤详情
        let params = {
          source: 'h5',
          cid: cid,
          random: Math.random(),
          access_token: getToken(),
        }
        http.get(api.checkin.getCheckinDetail, params).then(
          (res) => {
            let checkin = res.data
            this.hasUserInfo = true
            if (
              checkin.enable_audit == 1 &&
              checkin.audit_status == 2 &&
              checkin.has_joined == 0
            ) {
              // 加入签到审核中
              this.audit_status = 'ready'
              this.audit_name = checkin.owner
              return
            }
            if (checkin.enable_audit == 1 && checkin.audit_status == 0) {
              // 加入签到被拒绝了
              this.audit_status = 'reject'
              this.audit_name = checkin.owner
              return
            }
            if (
              checkin.end_date == checkin.start_date ||
              checkin.has_joined == 0 ||
              !this.hasUserInfo
            ) {
              checkin.canNotShowFlow = 1
            }
            if (checkin.end_date == 0) {
              let date= new Date()
              date.setYear(date.getFullYear() + 100)
              checkin.end_date = date.getTime() / 1000
            }

            this.checkin = checkin
            this.initMinImg()
            this.isNeedSign()
          },
          (err) => {
            if (err.data.sta == -1) {
              this.errcode = err.data.errcode || 0
            }
          }
        )
      } else {
        Dialog({
          title: '温馨提示',
          message: '分享链接错误，请检查分享链接',
        })
      }
    },
    initMinImg() {
      let param = {
          cid: this.checkin.cid,
          source: "h5",
      };
      http.get(api.checkin.getQr, param).then((res) => {     
          this.minQrcode = res.data.url;
      });
    },
    // 加入签到
    joinCheckin() {
      if (this.checkin.is_black == 1) {
        Dialog({
          title: '温馨提示',
          message: '您已被发起者加入黑名单，无法参与签到',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if (
        this.checkin.total_limit != 0 &&
        this.checkin.join_num * 1 >= this.checkin.total_limit
      ) {
        Dialog({
          title: '温馨提示',
          message: '该签到参与人数已满',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if(!this.is_can_sign){
        console.log(this.is_can_sign)
        Dialog({
          title: '温馨提示',
          message: this.miniMessage,
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      // 参与签到需要填写个人信息
      if (this.checkin.bind_eid != 0 && (this.checkin.req_name || this.checkin.bind_eid || (this.checkin.reg_info && this.checkin.reg_info.length > 0))) {
        this.checkin.refer_uid = this.refer_uid
        localStorage.setItem('checkin', JSON.stringify(this.checkin))
        this.$router.push({
          name: 'info',
        })
        return
      }
      if (this.checkin.template == 1 || this.checkin.template == 0) {
        //加入签到
        let params = {
          cid: this.checkin.cid,
          access_token: getToken(),
          referer:this.refer_uid,
          refer_type:29
        }
        http.post(api.checkin.joinCheckin, params).then((res) => {
          this.$router.go(0)
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}
.error-box {
  padding: rem(20) 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.error-icon {
  width: rem(120);
  height: rem(120);
}
.error-title {
  margin-top: rem(20);
  font-size: rem(32);
  font-weight: bold;
}
.error-text {
  margin-top: rem(20);
  font-size: rem(28);
  color: #333;
}
.content {
  width: rem(750);
  display: flex;
  flex-direction: column;
}
.icon-24 {
  width: rem(24);
  height: rem(24);
  margin-left: rem(10);
}
.top-10 {
  margin-top: rem(10);
}
.top-20 {
  margin-top: rem(20);
}
.button {
  width: rem(690);
  height: rem(88);
  line-height: rem(88);
  text-align: center;
  margin-top: rem(20);
  margin-bottom: rem(20);
  margin-left: rem(30);
  font-size: rem(36);
  border-radius: rem(8);
  color: #fff;
  background-color: #12b7f5;
}
.gray {
  background-color: #e5e5ea;
  color: #999999;
}
.yellow {
  background-color: #ffcc00;
}
.light {
  background-color: #71d4f9;
  color: #e5f7fe;
}

.audit-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: rem(400);
}
.audit-img {
  width: rem(226);
  height: rem(190);
}

.sign-code{
  background-color: #fff;
  margin-bottom: rem(100);
  padding-bottom: env(safe-area-inset-bottom);
  .sign-title{
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
  }
  .sign-img{
    width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
  }
}
.sign-panel{
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  .wx-panel{
    position: relative; 
  }
  .wx-btn{
    position: absolute;
    top: rem(20);
    left: rem(30);
    width: rem(690);
    height: rem(88);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/detail.vue